/**
 * Exposes env vars on window for use by pre-React scripts (e.g. index.html inline script).
 * Loads as a separate module so it may succeed even if main.tsx fails.
 */
declare global {
  interface Window {
    __API_BASE_URL__?: string;
  }
}

window.__API_BASE_URL__ = import.meta.env.VITE_API_BASE_URL ?? "";
